import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SettingsIconFre" */ './lazyIndex');
});
// Delayed Loaded Components
export var SettingIconFirstRunCallout = createLazyComponent(lazyModule, function (m) { return m.SettingIconFirstRunCallout; });
//# sourceMappingURL=index.js.map